import React from "react";
import {
  Input as ChakraInput,
  InputGroup,
  InputRightElement,
  type InputProps as ChakraInputProps,
} from "@chakra-ui/react";
import { ErrorIcon } from "../icons";

type BaseInputProps = {
  /**
   * Indicates if the input is invalid. If `true`, the input will be styled with an error state.
   * @default false
   */
  isInvalid?: boolean;

  /**
   * Indicates if the input is disabled. If `true`, the input will be styled with a disabled state.
   * @default false
   */
  isDisabled?: boolean;

  /**
   * Size of the input.
   * Large size should only be used for search inputs.
   *
   * @default "md"
   */
  size?: "md" | "lg";
};

export type InputProps = BaseInputProps & Omit<ChakraInputProps, "isInvalid" | "isDisabled">;

export function Input({ isInvalid, isDisabled, size = "md", ...props }: InputProps) {
  return (
    <InputGroup width="auto">
      <ChakraInput
        // Ask 1Password to not autofill this input and not show their icon inside
        data-1p-ignore
        isInvalid={isInvalid}
        isDisabled={isDisabled}
        size={size}
        {...props}
      />
      {isInvalid && !isDisabled && (
        <InputRightElement>
          <ErrorIcon color="brand.error" />
        </InputRightElement>
      )}
    </InputGroup>
  );
}
